import ShootCalendar from "@/components/ShootCalendar";

/**
 * /calendar — top-level Calendar page. All the grid + attendance-modal logic
 * lives in the reusable ShootCalendar component (also embedded inside the
 * /team → "Shoot Calendar" tab).
 */
export default function CalendarView() {
  return (
    <div data-testid="calendar-page">
      <ShootCalendar showHeader />
    </div>
  );
}
